import { noop } from 'lodash-es';
import { createContext, Dispatch, SetStateAction, useContext } from 'react';
import { RegionFixedExchangeRateValue } from 'services/config/region';

export const DashboardCurrencyCtx = createContext<{
  currency?: RegionFixedExchangeRateValue | undefined;
  onChange: (value?: RegionFixedExchangeRateValue) => void;
  dataUpdateTime?: string | undefined;
  setDataUpdateTime?: Dispatch<SetStateAction<string | undefined>>;
}>({
  onChange: noop,
  setDataUpdateTime: noop,
});

export const useDashboardCurrency = () => useContext(DashboardCurrencyCtx);
